import { render, staticRenderFns } from "./mSwitch.vue?vue&type=template&id=19b8568d&scoped=true&"
import script from "./mSwitch.vue?vue&type=script&lang=js&"
export * from "./mSwitch.vue?vue&type=script&lang=js&"
import style0 from "./mSwitch.vue?vue&type=style&index=0&id=19b8568d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8568d",
  null
  
)

export default component.exports